import { legacy_createStore as createStore, applyMiddleware } from "redux";
import rootReducer from "../reducer/index";
import logger from "redux-logger";
import { thunk } from "redux-thunk";

const middleware = [thunk];
const Store = createStore(rootReducer, applyMiddleware(...middleware))

export default Store;